import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function AlphabetValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const /** @type {?} */ pattern: any = /^[a-zA-Z\sa-zA-Z]+$/;

    if (control.value && !pattern.test(control.value)) {
      return { alphabetonly: { value: control.value } };
    }

    return null;
  };
}
